import { createSlotRecipe } from './runtime';

const paginationConfig = {"name":"pagination","slots":["root","item","ellipsis","prevTrigger","nextTrigger"]}

export const pagination = /* @__PURE__ */ createSlotRecipe(paginationConfig)